import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonKentimaMiddleKentimata';
const args = {};

export class OligonKentimaMiddleKentimata extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
